import TypographySectionContent from "containers/admin/clients/client/theme-page/preview/sub-tabs/typography/typography-section-content";

import {
  PreviewSidebarItemType,
  TypographyTabInputType,
} from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";

// Inputs for button label
export const TYPOGRAPHY_BUTTON_INPUTS: TypographyTabInputType[] = [
  { isRequired: false, name: "fontFamily", label: "Font family" },
  { isRequired: false, name: "fallbackFontFamily", label: "Fallback font family" },
  { isRequired: false, name: "fontSize", label: "Font size" },
  { isRequired: false, name: "lineHeight", label: "Line height" },
  { isRequired: false, name: "fontWeight", label: "Font weight" },
  { isRequired: false, name: "textColor", label: "Color" },
];

// Order of inputs for heading and subheading
const TYPOGRAPHY_WITH_ALIGNMENT = [
  { isRequired: false, name: "fontFamily", label: "Font family" },
  { isRequired: false, name: "fallbackFontFamily", label: "Fallback font family" },
  { isRequired: false, name: "fontSize", label: "Font size" },
  { isRequired: false, name: "alignment", label: "Alignment" },
  { isRequired: false, name: "lineHeight", label: "Line height" },
  { isRequired: false, name: "fontWeight", label: "Font weight" },
  { isRequired: false, name: "textColor", label: "Color" },
];

// Inputs for paragraph
const PARAGRAPH_WITH_ALIGNMENT = [
  ...TYPOGRAPHY_WITH_ALIGNMENT,
  { isRequired: false, name: "linkColor", label: "Link color" },
];

export const TYPOGRAPHY_TAB_SIDEBAR: PreviewSidebarItemType[] = [
  {
    titleText: "HEADING (H1)",
    children: (
      <TypographySectionContent
        sectionName="heading"
        sectionTitle="H1"
        content={TYPOGRAPHY_WITH_ALIGNMENT}
      />
    ),
  },
  {
    titleText: "SUBHEADING (H2)",
    children: (
      <TypographySectionContent
        sectionName="subHeading"
        sectionTitle="H2"
        content={TYPOGRAPHY_WITH_ALIGNMENT}
      />
    ),
  },
  {
    titleText: "PARAGRAPH",
    children: (
      <TypographySectionContent
        sectionName="paragraph"
        sectionTitle="Paragraph"
        content={PARAGRAPH_WITH_ALIGNMENT}
      />
    ),
  },
  {
    titleText: "BUTTON LABEL",
    children: (
      <TypographySectionContent
        sectionName="buttonLabel"
        sectionTitle="Button Label"
        content={TYPOGRAPHY_BUTTON_INPUTS}
      />
    ),
  },
];

export const FALLBACK_FONT_FAMILY_OPTIONS = [
  { label: "Arial (sans-serif)", value: "'Arial', Helvetica Neue, Helvetica, sans-serif" },
  { label: "Georgia (serif)", value: "'Georgia', Times, Times New Roman, serif" },
  {
    label: "Helvetica Neue (sans-serif)",
    value: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  { label: "Tahoma (sans-serif)", value: "'Tahoma', Verdana, Segoe, sans-serif" },
  { label: "Times New Roman (serif)", value: "'Times New Roman', serif" },
  {
    label: "Trebuchet MS (sans-serif)",
    value: "'Trebuchet MS', Lucida Grande, Lucida Sans Unicode, Lucida Sans, sans-serif",
  },
  { label: "Verdana (sans-serif)", value: "'Verdana', Tahoma, Segoe, sans-serif" },
];
